import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

type ProfileStackRoutes = {
  ProfileMain: object;
  EditName: {
    name: string;
    userId: string;
  };
  CreateStore: object;
  SetStore: {
    storeId: string;
    dirty?: boolean;
  };
};

export const ProfileStack = createNativeStackNavigator<ProfileStackRoutes>();

type ProfileStackNavigationProp<T extends keyof ProfileStackRoutes> =
  CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"Profile">,
    NativeStackNavigationProp<ProfileStackRoutes, T>
  >;

type ProfileStackRouteProp<T extends keyof ProfileStackRoutes> = RouteProp<
  ProfileStackRoutes,
  T
>;

export type ProfileStackScreenProps<T extends keyof ProfileStackRoutes> = {
  navigation: ProfileStackNavigationProp<T>;
  route: ProfileStackRouteProp<T>;
};
